import React, { useState } from "react";

import { Add } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles, withStyles } from "tss-react/mui";

import OverrideDateDialog from "./OverrideDateDialog";
import OverrideDateListItem from "./OverrideDateListItem";
import { useSchedule } from "../SchedulerProvider";
import Rule from "../store/Rule";

const useStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
  },
}));

const StyledButton = withStyles(Button, {
  root: {
    height: 32,
  },
});

const OverrideDatePanel: React.FC = observer(() => {
  const schedule = useSchedule();
  const { classes } = useStyles();
  const [overrideDatePanelVisibility, setOverrideDatePanelVisibility] =
    useState<boolean>(false);
  const overrideDates: Rule[] = schedule.dateRules;
  function renderOverrides() {
    if (overrideDates.length > 0) {
      return overrideDates
        .filter((e) => !e._destroy)
        .map((e, index) => {
          return <OverrideDateListItem key={index} override={e} />;
        });
    } else {
      return displayNoOverride();
    }
  }
  function displayNoOverride() {
    return (
      <Typography variant="body1" textAlign="center" color="GrayText">
        You have no override dates yet. Add dates to override in your weekly
        hours.
      </Typography>
    );
  }

  return (
    <div className={classes.root}>
      <Box display="flex" justifyContent="space-between">
        <Typography variant="body1" color="black" fontWeight="700">
          Add override dates
        </Typography>
        <StyledButton
          variant="outlined"
          startIcon={<Add />}
          onClick={() => {
            setOverrideDatePanelVisibility(true);
          }}
        >
          Add
        </StyledButton>
      </Box>
      <Box display="flex" flexDirection={"column"}>
        {renderOverrides()}
      </Box>
      <OverrideDateDialog
        visible={overrideDatePanelVisibility}
        onClose={() => setOverrideDatePanelVisibility(false)}
      />
    </div>
  );
});

export default OverrideDatePanel;
